import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "footer small",
  role: "contentinfo"
}
const _hoisted_2 = { class: "footer-small container-fluid" }
const _hoisted_3 = { class: "footer-small-links" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "footer-small-dnvgl" }
const _hoisted_7 = { class: "my-3 mr-3 my-sm-0 mr-sm-0 title-spacing" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<span class=\"mx-3 d-none d-sm-inline\"> | </span><ul class=\"footer-some\"><li class=\"mr-2\"><a class=\"some-circle small\" href=\"https://www.linkedin.com/showcase/dnv-digital/\" target=\"_blank\"><i class=\"fab fa-linkedin-in\"></i></a></li><li class=\"mr-2\"><a class=\"some-circle small\" href=\"https://twitter.com/DNV_Group\" target=\"_blank\"><i class=\"fab fa-twitter\"></i></a></li><li class=\"mr-2\"><a class=\"some-facebook small\" href=\"https://www.facebook.com/dnvglsoftware/\" target=\"_blank\"><i class=\"fab fa-facebook\"></i></a></li><li><a class=\"some-circle some-youtube small\" href=\"https://www.youtube.com/user/dnvsoftware\" target=\"_blank\"><i class=\"fab fa-youtube\"></i></a></li></ul>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
          return (_openBlock(), _createElementBlock("li", {
            key: link.name,
            id: link.id
          }, [
            _createElementVNode("a", {
              href: link.url
            }, _toDisplayString(link.name), 9, _hoisted_5)
          ], 8, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, " © DNV AS " + _toDisplayString(new Date().getFullYear()), 1),
        _hoisted_8
      ])
    ])
  ]))
}